import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import AzureResourceCSP from "../../../models/csp/AzureResourceCSP";
import SubscriptionCSP from "../../../models/csp/SubscriptionCSP";
import azureResourceService from "../../../services/csp/azureResourceService";
import subscriptionService from "../../../services/csp/subscriptionService";
import { RootState } from "../../index";

const namespaced = true;

interface AzureResourceState {
  azureResources: AzureResourceCSP[];
}

const state: AzureResourceState = {
  azureResources: []
};

const mutations: MutationTree<AzureResourceState> = {
  setAzureResources(state, resources: AzureResourceCSP[]) {
    state.azureResources = resources;
  }
};

const actions: ActionTree<AzureResourceState, RootState> = {
  async loadAzureResourcesCSP({ commit }, customerId: string) {
    const azPlansResources: AzureResourceCSP[] = [];
    const azPlans: SubscriptionCSP[] =
      await subscriptionService.methods.getAzurePlanIdsByTenantId(customerId);
    for (const azPlan of azPlans) {
      const azPlanResources: AzureResourceCSP[] =
        await azureResourceService.methods.getAzureResourcesCSP(
          customerId,
          azPlan.getId
        );
      azPlansResources.push(...azPlanResources);
    }
    commit("setAzureResources", azPlansResources);
  }
};

const getters: GetterTree<AzureResourceState, RootState> = {
  getAzureResourcesCSPByAzurePlanId:
    state =>
    (azurePlanId: string): AzureResourceCSP[] => {
      return state.azureResources.filter(
        resource => resource.getAzurePlanId === azurePlanId
      );
    }
};

export const azureResourceModuleCSP: Module<AzureResourceState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
